export const hasCourses = (details) => {
  const courses = details?.courses;
  return Array.isArray(courses) && courses.length > 0;
};

export const getAccessibleCourses = (userDetails, catalogue) => {
  const access = userDetails?.courses;
  if (!Array.isArray(access) || !Array.isArray(catalogue)) {
    return [];
  }

  const accessByCode = new Map(access.filter((course) => course?.code).map((course) => [course.code, course]));

  return catalogue
    .filter((item) => accessByCode.has(item.code))
    .map((item) => ({
      ...item,
      completed: !!accessByCode.get(item.code)?.completed,
    }));
};

export const getCatalogueCourseByCode = (catalogue, code) => {
  if (!code || !Array.isArray(catalogue)) {
    return null;
  }

  return catalogue.find((course) => course.code === code) || null;
};

export const getAccessibleCourseByCode = (userDetails, catalogue, code) => {
  if (!code) {
    return null;
  }

  return getAccessibleCourses(userDetails, catalogue).find((course) => course.code === code) || null;
};
